var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamCreationIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5003 73.3635C57.5834 73.3635 73.864 57.0829 73.864 36.9999C73.864 16.9168 57.5834 0.63623 37.5003 0.63623C17.4173 0.63623 1.13672 16.9168 1.13672 36.9999C1.13672 57.0829 17.4173 73.3635 37.5003 73.3635Z",
    fill: "#ECF1F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.8643,
    cy: 15.9092,
    r: 8,
    fill: "#F2994A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5485 16.2364H66.7267V19.2328H65.2649V16.2364H62.4576V14.9055H65.2649V11.9237H66.7267V14.9055H69.5485V16.2364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2283 13.2183L48.8115 14.0784",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6826 12.7129L48.3235 11.2793",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9732 33.8408L53.5059 33.8746",
    stroke: "white",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2051 9.72637L28.5517 11.1467",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1055 11.1729L27.2733 12.3587",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.218 13.7627L24.6641 13.4644",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1366 26.573C25.3968 26.573 28.0398 23.93 28.0398 20.6698C28.0398 17.4095 25.3968 14.7666 22.1366 14.7666C18.8763 14.7666 16.2334 17.4095 16.2334 20.6698C16.2334 23.93 18.8763 26.573 22.1366 26.573Z",
    fill: "#D8DFE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.319 30.4539C43.5364 30.4539 46.9553 27.035 46.9553 22.8175C46.9553 18.6001 43.5364 15.1812 39.319 15.1812C35.1015 15.1812 31.6826 18.6001 31.6826 22.8175C31.6826 27.035 35.1015 30.4539 39.319 30.4539Z",
    fill: "#D8DFE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2788 33.1055L20.8003 34.6065",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6918 32.9105L19.9884 31.8844",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.498 30.6519L18.9551 30.4646",
    stroke: "#1E247E",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5121 65.966C7.39794 64.3393 8.04294 60.7262 11.5362 59.2878C15.0294 57.8494 16.4164 57.4898 16.6732 57.4898L17.9575 54.1507C17.0157 53.6084 15.1492 51.5821 15.2177 47.8149C15.3033 43.1059 16.9301 41.736 17.9575 41.3935C18.9849 41.0511 21.2966 40.1093 23.1802 41.3935C24.6871 42.421 25.4063 43.7624 25.5775 44.3046C25.8059 45.1894 26.1255 47.2842 25.5775 48.5856C25.1279 49.9344 24.9674 52.3915 23.1802 53.7518M23.1802 53.7518C22.5851 54.2048 21.8096 54.5361 20.7829 54.6645L23.1802 53.7518ZM23.1802 54.1507L23.7795 56.8906M23.7795 56.8906L29.7728 59.2878M23.7795 56.8906L23.1802 57.4898L22.2384 58.4317L20.3548 60.3153L17.3582 57.4898",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0381 59.2878C50.5313 57.8494 51.9183 57.4898 52.1751 57.4898L53.4594 54.1507C52.5176 53.6084 50.6511 51.5821 50.7196 47.8149C50.8052 43.1059 52.432 41.736 53.4594 41.3935C54.4868 41.0511 56.7985 40.1093 58.6821 41.3935C60.189 42.421 60.9082 43.7624 61.0795 44.3046C61.3078 45.1894 61.6274 47.2842 61.0795 48.5856C60.6298 49.9344 60.4693 52.3915 58.6821 53.7518M58.6821 53.7518C58.087 54.2048 57.3115 54.5361 56.2848 54.6645L58.6821 53.7518ZM58.6821 54.1507L59.2815 56.8906M59.2815 56.8906L65.2748 59.2878C66.6447 59.6017 69.1635 59.9753 69.1635 64.5645M59.2815 56.8906L58.6821 57.4898L57.7403 58.4317L55.8567 60.3153L52.8601 57.4898",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0235 43.5415C60.6915 43.8734 56.8743 45.2012 54.2188 45.0352",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2491 43.8921C24.9171 44.224 21.0998 45.5518 18.4443 45.3858",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5952 70.6364C20.443 68.4674 21.303 63.6499 25.9607 61.732C30.6183 59.8142 32.4676 59.3347 32.8101 59.3347L34.5224 54.8826C33.2667 54.1596 30.778 51.4578 30.8694 46.4349C30.9835 40.1562 33.1525 38.3297 34.5224 37.873C35.8923 37.4164 38.9746 36.1607 41.4861 37.873C43.4952 39.2429 44.4542 41.0315 44.6825 41.7545C44.9869 42.9341 45.4131 45.7272 44.6825 47.4624C44.083 49.2608 43.869 52.5369 41.4861 54.3507M41.4861 54.3507C40.6925 54.9547 39.6585 55.3965 38.2896 55.5676L41.4861 54.3507ZM41.4861 54.8826L42.2852 58.5357M42.2852 58.5357L50.2762 61.732C52.1028 62.1506 55.7558 64.5174 55.7558 70.6364M42.2852 58.5357L41.4861 59.3347L40.2303 60.5906L37.7189 63.102L33.7233 59.3347",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2546 41.2046C43.812 41.6472 38.7223 43.4175 35.1816 43.1962",
    stroke: "#828282",
    strokeWidth: 1.09091
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1797 73.3633H73.8614",
    stroke: "#828282",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44336 73.3633H68.4148",
    stroke: "#828282",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13672 73.3633H4.66176",
    stroke: "#828282",
    strokeWidth: 1.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7587 35.8718C61.0189 35.8718 63.6618 33.2289 63.6618 29.9686C63.6618 26.7084 61.0189 24.0654 57.7587 24.0654C54.4984 24.0654 51.8555 26.7084 51.8555 29.9686C51.8555 33.2289 54.4984 35.8718 57.7587 35.8718Z",
    fill: "#D8DFE5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCreationIllustration);
export default __webpack_public_path__ + "static/media/TeamCreationIllustration.19ae9606456df54cdcba8e418953407e.svg";
export { ForwardRef as ReactComponent };